import useBaseForm from "../../../../hooks/useBaseForm";
import { FieldInterface, FormValues } from "../../../../types";

export default function useController(JobFields: FieldInterface[], defaultValues: FormValues) {
  const { fields, values, setValues, errors, setErrors } = useBaseForm(JobFields, defaultValues);
  return { fields, values, setValues, errors, setErrors };
}
